import type { Locale } from '@packages/config';
import { getCmsDataCacheKey } from './getCmsDataCacheKey';

export const getSurveyCacheKey = (device: 'web' | 'mob', locale: Locale): string =>
  getCmsDataCacheKey('active-survey', device, locale);
